var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:_vm.ClassObject,staticStyle:{"cursor":"pointer"},attrs:{"plain":""},on:{"click":function($event){return _vm.onClicked(_vm.column, _vm.row)}}},[_vm._v(" "+_vm._s(_vm.rowValue)+" "),(_vm.Months.includes(_vm.column.property))?_c('span',[_vm._v("%")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }